export default __webpack_public_path__ + "static/media/NavBar.dfa2db7d.png";